/* eslint-disable  */
import React, { useEffect, useState } from "react";
import RenderAdminPage from "../RenderAdminPage";
import { useDispatch, useSelector } from "react-redux";
import {
  GetLoanAllReport,
  GetLoanReport,
} from "../../services/Actions/dataAction";
import { RolesContants } from "../../contants";
import { GetUserProfile } from "../../services/Actions/authActions";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Loader";
import { bindActionCreators } from "redux";
import { dataActionCreators } from "../../services/Actions";
import { FaDownload, FaRegFilePdf } from "react-icons/fa";
import "./AdminReport.css";
import { FormControlLabel, Switch } from "@material-ui/core";

function AdminReport() {
  const dispatch = useDispatch();
  const { ResetDataResponse } = bindActionCreators(
    dataActionCreators,
    dispatch
  );
  const [generateAllReport, setGenerateAllReport] = useState(false);
  const [oneDomainReport, setOneDomainReport] = useState(false);

  const [formData, setFormData] = useState({
    category: "",
    fromDate: "",
    toDate: "",
  });

  const data = useSelector((state) => state?.data);
  const user = useSelector((state) => state?.auth);
  const { isLoading, response } = data;

  useEffect(() => {
    dispatch(GetUserProfile());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleChangeGenerateReport = () => {
    setGenerateAllReport(!generateAllReport);
  };
  const handleChangeOneDomain = () => {
    setOneDomainReport(!oneDomainReport);
  };

  const handleGenerate = () => {
    if (
      user?.role?.includes(RolesContants.ADMIN, RolesContants.LOAN_OFFICER_HEAD)
    ) {
      if (generateAllReport == false && oneDomainReport == false) {
        if (!formData.fromDate || !formData.toDate) {
          toast.error("Choose the range. This is required");
          return;
        }
        dispatch(
          GetLoanReport({
            ...formData,
            is_all: generateAllReport,
            isOneDomain: oneDomainReport,
          })
        );
      } else if (generateAllReport == true && oneDomainReport == true) {
        dispatch(
          GetLoanReport({
            ...formData,
            is_all: generateAllReport,
            isOneDomain: oneDomainReport,
          })
        );
      } else if (oneDomainReport == true) {
        if (!formData.fromDate || !formData.toDate) {
          toast.error("Choose the range. This is required");
          return;
        }
        dispatch(
          GetLoanReport({
            ...formData,
            is_all: generateAllReport,
            isOneDomain: oneDomainReport,
          })
        );
      } else {
        dispatch(
          GetLoanReport({
            ...formData,
            is_all: generateAllReport,
            isOneDomain: oneDomainReport,
          })
        );
      }

      console.log(formData);
    } else {
      toast.error("You are not authorized to generate report on loans");
    }
  };

  const handleGenerateAll = () => {
    dispatch(GetLoanAllReport());
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    }
  }, [response?.state, ResetDataResponse]);

  return (
    <div>
      <RenderAdminPage title="Report">
        {isLoading && <Loader />}

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6 sm:p-8 mt-2">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 dark:bg-indigo-900/30 mb-3">
              <FaRegFilePdf className="text-indigo-600 dark:text-indigo-400 text-xl" />
            </div>
            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">Generate Report</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
            <div>
              <label htmlFor="category" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Status</label>
              <select
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="" disabled>Select Status</option>
                <option value="submitted">Submitted Report</option>
                <option value="booked">Booked Report</option>
                <option value="initiated">Initiated Report</option>
                <option value="paid">Paid Report</option>
                <option value="authorized">Authorized Report</option>
                <option value="rejected">Rejected Report</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Select all</label>
              <FormControlLabel
                control={<Switch checked={generateAllReport} onChange={handleChangeGenerateReport} />}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">One Domain</label>
              <FormControlLabel
                control={<Switch checked={oneDomainReport} onChange={handleChangeOneDomain} />}
              />
            </div>

            <div>
              <label htmlFor="fromDate" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">From</label>
              <input
                type="date"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                id="fromDate"
                name="fromDate"
                readOnly={generateAllReport ? true : false}
                value={formData.fromDate}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="toDate" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">To</label>
              <input
                type="date"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                id="toDate"
                readOnly={generateAllReport ? true : false}
                name="toDate"
                value={formData.toDate}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 pt-4 border-t border-slate-100 dark:border-gray-700">
            <button
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition-colors shadow-sm"
              onClick={handleGenerate}
            >
              <FaDownload /> Generate
            </button>
            <button
              onClick={handleGenerateAll}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm"
            >
              <FaDownload /> Generate All
            </button>
          </div>
        </div>

        <ToastContainer autoClose={3000} />
      </RenderAdminPage>
    </div>
  );
}

export default AdminReport;
